<template>
  <div id="newRequest">
    <NewRequestMobile :request="request" :property="Property" :category="category"
                      :categories_lv1="categories_lv1" :categories_lv2="categories_lv2" :categories_lv3="categories_lv3"
                      :back="back" :send="send" :setImageData="setImageData"
                      v-if="request"
                      v-show="!$store.state.isDesktop"
                      ref="newRequestMobile"
    ></NewRequestMobile>

    <NewRequestDesktop :request="request" :property="Property" :category="category"
                      :categories_lv1="categories_lv1" :categories_lv2="categories_lv2" :categories_lv3="categories_lv3"
                      :back="back" :send="send" :setImageData="setImageData"
                      v-if="request"
                      v-show="$store.state.isDesktop"
                      ref="newRequestDesktop"
    ></NewRequestDesktop>
  </div>
</template>

<script>

  //@ts-check
  import Requests,{Request} from '../../core/Requests';
  import FileUploader from "../components/FileUploader";
  import Property from "../../core/Property";
  import RequestCategories from "../../core/RequestCategories";
  import NewRequestMobile from '@/components/mobile/NewRequest';
  import NewRequestDesktop from '@/components/desktop/NewRequest';

  export default {

    name: "newRequest",

    components: {
      FileUploader,
      NewRequestMobile,
      NewRequestDesktop
    },

    data() {
      return {
        category: {
          lv1: null,
          lv2: null,
          lv3: null,
        },
        request: null,
        Property,
        RequestCategories
      };
    },

    computed: {
      categories_lv1() {
        return RequestCategories.findByParent(null) || []
      },
      categories_lv2() {
        return this.category.lv1
          ? RequestCategories.findByParent(this.category.lv1)
          : []
      },
      categories_lv3() {
        return this.category.lv2
          ? RequestCategories.findByParent(this.category.lv2)
          : []
      },
      highestCategory() {
        return  this.category.lv3 || this.category.lv2 || this.category.lv1
      }
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "requests.new",
        headerIcon: "/svg/history.svg"
      });
      this.request = new Request();
    },

    methods: {
      back() {
        this.$router.push("/requests");
      },
      checkFormValidity() {
        return (this.$store.state.isDesktop ?
          !this.$refs.newRequestDesktop.$validate.valid()
          : !this.$refs.newRequestMobile.$validate.valid())
      },
      async send() {
        if (this.checkFormValidity()) {
          showAffirmation(this.$t("form.oops"), this.$t("form.info_missing_text"));
          return;
        }
        showSpinner();
        let result;
        try {
          result = await Requests.createRequest({
            title: this.request.title,
            body: this.request.body,
            property: this.request.property,
            unit: this.request.unit,
            phoneNumber: this.request.phoneNumber,
            emergency: this.request.emergency,
            canAccessIfAbsent: this.request.canAccessIfAbsent,
            animal: this.request.animal,
            alarm: this.request.alarm,
            alarmCode: this.request.alarmCode,
            image: this.request.imageData,
            category: this.highestCategory
          });
        } catch (e) {
          showAffirmation(this.$t("form.oops"), this.$t("form.could_not_send"));
          hideSpinner();
          return;
        }
        hideSpinner();
        if (result.status == 200) {
          this.$router.push("/requests");
        }
      },
      setImageData(data) {
        this.request.imageData = data;
      }
    }

  }

</script>

<style lang="scss" scoped>

  #newRequest {
    background-color: #f2f3f4;
    display: flex;
    flex-direction: column;
  }
  
</style>